import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Alert, Fade} from 'react-bootstrap';

class FadingAlert extends Component {
    static propTypes = {
        alertTimeout: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['false'])]),
        bsStyle: PropTypes.string,
        onExited: PropTypes.func,
    };

    static defaultProps = {
        alertTimeout: false,
        bsStyle: 'success',
    };

    constructor(props) {
        super(props);
        this.state = {
            show: false,
        }
    }

    handleDismiss = () => {
        if (this.alertTimeout) {
            clearTimeout(this.alertTimeout);
        }
        this.setState({show: false});
    };

    componentDidMount = () => {
        setTimeout(() => {
            this.setState({show: true});
        }, 0);
        if (this.props.alertTimeout !== false) {
            this.alertTimeout = setTimeout(this.handleDismiss, this.props.alertTimeout);
        }
    };

    componentWillUnmount = () => {
        if (this.alertTimeout) {
            clearTimeout(this.alertTimeout);
        }
    };

    render() {
        return (
            <Fade in={this.state.show} onExited={this.props.onExited}>
                <Alert bsStyle={this.props.bsStyle} onDismiss={this.handleDismiss}>{this.props.children}</Alert>
            </Fade>
        );
    }
}

export default FadingAlert;



// WEBPACK FOOTER //
// ./src/FadingAlert.js